import { Tab } from '@material-ui/core';

import styled from '../../lib/theme';

export const ModalContent = styled.div`
  box-shadow:
    0 3px 6px rgba(0, 0, 0, 0.16),
    0 3px 6px rgba(0, 0, 0, 0.23);
  border-radius: 6px;
  width: 400px;
  height: calc(100%);
`;

export const WidgetGeneratorContainer = styled.div`
  padding: 2rem;
  font-family: proxima-nova, sans-serif;
  font-size: 1.2rem;
  height: 94vh;
  overflow: auto;
`;

export const StyledTab = styled(Tab)`
  font-size: 1.2rem !important;
  font-weight: 800 !important;
`;

export const TabContainer = styled.div`
  display: flex;
  height: 100%;
  padding: 2rem;
  overflow: auto;
  flex-shrink: 0;
`;

export const GeneratorContent = styled.div`
  box-shadow:
    0 3px 6px rgba(0, 0, 0, 0.16),
    0 3px 6px rgba(0, 0, 0, 0.23);
  border-radius: 6px;
  display: flex;
  padding: 2rem;
  align-items: baseline;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
`;

export const RowContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Column = styled.div`
  padding-right: 5rem;
`;

export const WidgetCodeContainer = styled.div`
  display: -webkit-box;
  -webkit-box-sizing: border-box;
  -webkit-box-orient: vertical;
  -webkit-box-flex: 1;
  width: 0px;
  flex: 1;
  height: 600px;
`;

export const ImportButtonContainer = styled.div`
  margin-left: 5rem;
`;
